import React, { FC, memo } from 'react';
import { ZonesTable } from './ZonesTable';
import { TableFilterContextProvider } from 'features/TableFilter';
import { CreateZoneModal } from 'widgets/CreateZoneModal';

export const ZonesList: FC = memo(() => {
  return (
    <>
      <TableFilterContextProvider>
        <ZonesTable />
      </TableFilterContextProvider>
      <TableFilterContextProvider>
        <CreateZoneModal />
      </TableFilterContextProvider>
    </>
  );
});
